// extracted by mini-css-extract-plugin
export var pillTrigger = "_6a-0";